module.exports = __webpack_public_path__ + "static/media/gucci-sun.980447c9.jpg";